import GuardianRunner from "@/router/guardian-runner"
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router"
import { ensureIsAnonymous } from "@/router/guardians"

export default [
  {
    path: "/login",
    name: "login",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAnonymous])
    },
    component: () => import("@/modules/login/pages/login-page/LoginPage.vue")
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("@/modules/login/pages/forgot-password-page/ForgotPasswordPage.vue"),
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAnonymous])
    }
  }
]
